/* @flow */
import * as React from 'react';

import EventTracking from 'lib/EventTracking';
import FreeClassLimitsLearnMoreDialog from 'groups/components/FreeClassLimitsLearnMoreDialog';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import Row from 'components/Row';
import Text from 'components/Text';

export type Props = {
  groupCode: ?string,
  showWarning: ?boolean,
  numberOfClassesLimit: number,
  isExistingGroup: boolean,
};

export const limitReachedEventKey = 'limit_reached_banner';
export const proactiveEventKey = 'proactive_banner';
export const existingGroupWarningCopy = 'Announcements aren’t available for this class.';
export const newGroupWarningCopy = 'Announcements won’t be available for this class.';

class GroupCreationLimitNotice extends React.Component<Props> {
  componentDidMount() {
    this.trackEvent('view');
  }

  trackEvent = (event: string) => {
    if (!this.props.numberOfClassesLimit) {
      return;
    }

    const eventKeyPrefix = `free_product_limits.create_class_modal.${
      this.props.showWarning ? limitReachedEventKey : proactiveEventKey
    }`;
    EventTracking.trackKey(`${eventKeyPrefix}.${event}`);
  };

  render() {
    const { numberOfClassesLimit, groupCode, isExistingGroup } = this.props;
    const warningText = isExistingGroup ? existingGroupWarningCopy : newGroupWarningCopy;

    return (
      <Row size="medium">
        <Text size="xsmall" align="left" lineHeight="large">
          {this.props.showWarning && (
            <Text weight="semibold" data-test="creation-limit-warning" color="lava">
              {warningText}
            </Text>
          )}
          {/* TODO: fetch membership limit from backend instead of hardcoding */}
          {` Your free Remind account includes
      announcements to up to ${numberOfClassesLimit} classes with 150 people each. `}
          <ModalTrigger
            onClick={() => this.trackEvent('click')}
            modal={
              <FreeClassLimitsLearnMoreDialog
                onRequestHide={() => {}}
                uiContext="create_or_edit_group"
                peopleListUrl={groupCode ? `/classes/${groupCode}/people` : undefined}
              />
            }>
            <Link weight="semibold">Learn more</Link>
          </ModalTrigger>
        </Text>
      </Row>
    );
  }
}

export default GroupCreationLimitNotice;
